import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgStarter = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <ellipse
      cx={14.444}
      cy={16.7}
      fill="#00C5F2"
      rx={4.444}
      ry={4.4}
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M18.889 25.5V31H10v-5.5c0-2.43 1.99-4.4 4.444-4.4 2.455 0 4.445 1.97 4.445 4.4"
      clipRule="evenodd"
    />
    <ellipse
      cx={23.889}
      cy={13.95}
      fill="#85E3F9"
      rx={5}
      ry={4.95}
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M28.889 24.278c0-2.97-2.239-5.378-5-5.378s-5 2.408-5 5.378V31h10z"
      clipRule="evenodd"
    />
    <ellipse
      cx={27.778}
      cy={22.2}
      fill="#00C5F2"
      rx={2.222}
      ry={2.2}
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgStarter);

export default ForwardRef;
